export default __webpack_public_path__ + "static/media/Wacky-duck-contact.ed8b1f2f.png";